export const NotificationType = Object.freeze({
  Alert: 'alerts',
  Message: 'messages',
});
